import { AllowedValueTypeEnum, getUnitOfMeasureLabel, UnitOfMeasure } from 'api';
import { BooleanSelectField, TextField, useFormContext, useWatch } from 'form';
import { InputAdornment, Stack } from 'ui';

type Props = {
  name: string;
  allowedValueType?: AllowedValueTypeEnum;
  unit?: UnitOfMeasure;
  disabled?: boolean;
};
export const MaterialSupportedComponentValue = ({ name, allowedValueType, unit, disabled }: Props) => {
  const form = useFormContext();
  const minValue = useWatch({
    control: form.control,
    name: `${name}.min_value`,
  });
  const maxValue = useWatch({
    control: form.control,
    name: `${name}.max_value`,
  });
  const booleanValue = useWatch({
    control: form.control,
    name: `${name}.boolean_value`,
  });

  const shouldDisplayMinValue =
    allowedValueType === AllowedValueTypeEnum.MIN ||
    allowedValueType === AllowedValueTypeEnum.RANGE ||
    minValue !== undefined;
  const shouldDisplayMaxValue =
    allowedValueType === AllowedValueTypeEnum.MAX ||
    allowedValueType === AllowedValueTypeEnum.RANGE ||
    maxValue !== undefined;
  const shouldDisplayBooleanValue = allowedValueType === AllowedValueTypeEnum.YES_NO || booleanValue !== undefined;

  return (
    <Stack direction="row" spacing={1}>
      {shouldDisplayMinValue ? (
        <TextField
          name={`${name}.min_value`}
          data-testid={`${name}.min_value`}
          label="Value"
          value={minValue}
          type="number"
          required
          InputProps={{
            endAdornment: <InputAdornment position="end">{getUnitOfMeasureLabel(unit || '')}</InputAdornment>,
            startAdornment: <InputAdornment position="start">Min: </InputAdornment>,
          }}
          disabled={disabled}
        />
      ) : null}
      {shouldDisplayMaxValue ? (
        <TextField
          name={`${name}.max_value`}
          data-testid={`${name}.max_value`}
          label="Value"
          value={maxValue}
          type="number"
          required
          InputProps={{
            endAdornment: <InputAdornment position="end">{getUnitOfMeasureLabel(unit || '')}</InputAdornment>,
            startAdornment: <InputAdornment position="start">Max: </InputAdornment>,
          }}
          disabled={disabled}
        />
      ) : null}
      {shouldDisplayBooleanValue ? (
        <BooleanSelectField
          name={`${name}.boolean_value`}
          data-testid={`${name}.boolean_value`}
          label="Boolean value"
          defaultValue={booleanValue}
          required
          disabled={disabled}
        />
      ) : null}
    </Stack>
  );
};
